export default [{
    title: 'Parametres',
    icon: 'SettingsIcon',
    typeUser: 'assureur',
    tagVariant: 'light-danger',
    route: 'parametres',
}]